const yogaClassesData = [
  {
    title: 'For beginners',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.',
    'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
            + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
            + '                    nobis optio sunt, velit.'],

  },
  {
    title: 'Ashtanga vinyasa',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.'],
  },
  {
    title: 'Universal',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.'],
  },
  {
    title: 'Kundalini',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.'],
  },
  {
    title: 'Iyengar',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.'],
  },
  {
    title: 'Therapy',
    about: ['Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit, incidunt molestiae porro possimus\n'
        + '                    sunt temporibus! Accusantium architecto, at dicta doloribus eius ex incidunt, minus mollitia nihil\n'
        + '                    nobis optio sunt, velit.'],
  },
];

export default yogaClassesData;
